import Card from 'components/Card';
import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import TelegramLoginWidget from 'pages/onboarding/Login/TelegramLoginWidget';
import LoginForm from 'pages/onboarding/Login/LoginForm';
import SelectableItem from 'components/SelectableItem';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

enum LoginType {
  Login = 'login',
  Telegram = 'telegram',
}

const getLoginTypes = (t: TFunction) => [
  {
    type: LoginType.Telegram,
    title: t('loginPage.telegramLoginTitle'),
  },
  {
    type: LoginType.Login,
    title: t('loginPage.baseLoginTitle'),
  },
];

const Login = () => {
  const { t } = useTranslation();
  const [loginType, setLoginType] = useState(LoginType.Login);

  const onSelectLoginType = (type: LoginType) => setLoginType(type);

  const [searchParams] = useSearchParams();

  const isToken = searchParams.has('hash');

  useEffect(() => {
    if (isToken) setLoginType(LoginType.Telegram);
  }, [isToken]);

  return (
    <Card>
      <Typography variant='h28' sx={{ mb: 1.5 }}>
        {t('loginPage.title')}
      </Typography>
      <Typography component='p' variant='subtitle18rg' sx={{ mb: { xs: 3, sm: 3.5 } }}>
        {t('loginPage.subtitle')}
      </Typography>
      <Stack spacing={1.5} mb={2}>
        {getLoginTypes(t).map(({ type, title }) => {
          const isSelected = type === loginType;
          return (
            <SelectableItem
              key={`login-type-${type}`}
              title={title}
              isSelected={isSelected}
              onSelect={() => onSelectLoginType(type)}
            />
          );
        })}
      </Stack>
      {loginType === LoginType.Telegram ? <TelegramLoginWidget /> : <LoginForm />}
    </Card>
  );
};

export default Login;
